import React from 'react';
import Badge from './Badge';

const BadgeList = ({ badges, size = 'small', showTooltip = true, className = '' }) => {
  const list = Array.isArray(badges) ? badges : [];
  if (list.length === 0) {
    return null;
  }

  return (
    <div className={`flex gap-1 ${className}`}>
      {list.map(badge => (
        <Badge 
          key={badge.id} 
          badge={badge} 
          size={size} 
          showTooltip={showTooltip} 
        />
      ))}
    </div>
  );
};

export default BadgeList;
